import { Component, Input, OnInit, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CompanyFilterService } from '@services/company-filter/company-filter.service';

/**
 * "Azienda" menu for the superadmin, shown at the top of the pages. Nothing for the other roles.
 * mode 'all': "All companies" plus each company (shared by the pages); 'documents': one company at a time.
 */
@Component({
  selector: 'app-company-filter',
  standalone: true,
  imports: [AsyncPipe, FormsModule, TranslateModule, TablerIconsModule],
  template: `
    @if (filter.isSuperadmin$ | async) {
      <label class="xr-company-filter">
        <i-tabler name="building" class="icon-18 d-flex xr-company-filter__icon" aria-hidden="true"></i-tabler>
        <span class="xr-sr-only">{{ 'company_filter.label' | translate }}</span>
        @if (mode === 'documents') {
          <select [ngModel]="filter.documentsCompany$ | async" (ngModelChange)="filter.selectDocumentsCompany(+$event)"
                  [attr.aria-label]="'company_filter.label' | translate">
            @for (company of filter.companies$ | async; track company.id) {
              <option [ngValue]="company.id">{{ company.name }}</option>
            }
          </select>
        } @else {
          <select [ngModel]="filter.selected$ | async" (ngModelChange)="filter.select($event)"
                  [attr.aria-label]="'company_filter.label' | translate">
            <option [ngValue]="null">{{ 'company_filter.all' | translate }}</option>
            @for (company of filter.companies$ | async; track company.id) {
              <option [ngValue]="company.id">{{ company.name }}</option>
            }
          </select>
        }
      </label>
    }
  `,
  styles: [`
    :host {
      display: inline-flex;
      max-width: 100%;
    }
    @media (max-width: 900px) {
      :host,
      .xr-company-filter,
      select {
        width: 100%;
      }
    }
    .xr-company-filter {
      position: relative;
      display: inline-flex;
      align-items: center;
      min-width: 0;
      max-width: 100%;
    }
    .xr-company-filter__icon {
      position: absolute;
      left: 12px;
      color: var(--xr-muted);
      pointer-events: none;
    }
    select {
      appearance: none;
      max-width: 100%;
      min-height: 44px;
      padding: 0 36px 0 38px;
      border: 1px solid #D5DCE5;
      border-radius: 12px;
      background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%235D6D7E' d='M6 8 0 0h12z'/%3E%3C/svg%3E") no-repeat right 14px center;
      font: inherit;
      font-size: 14px;
      font-weight: 600;
      color: var(--xr-navy);
      cursor: pointer;
      text-overflow: ellipsis;
    }
    select:focus-visible {
      outline: 3px solid var(--xr-navy);
      outline-offset: 2px;
    }
  `]
})
export class CompanyFilterComponent implements OnInit {
  protected filter = inject(CompanyFilterService);
  @Input() mode: 'all' | 'documents' = 'all';

  ngOnInit(): void {
    this.filter.load();
  }
}
